// "Tamaño: 150 ml" / "Porcentaje: 12%" a partir de la opción de una variante.
// Se lee la opción (no `variant.title`, que en el backend es inconsistente:
// "Tamaño", "Tamano", "PORCENTAJE", el nombre del producto…) y se ignoran los
// placeholders "Default option" de Medusa.

const isPlaceholder = (txt) =>
  !txt || !String(txt).trim() || /^default (option|variant)( value)?$/i.test(String(txt).trim());

const normalizeSpecValue = (v) => String(v).trim().replace(/(\d)\s*ml\b/gi, '$1 ml');

const normalizeSpecLabel = (t) => {
  const clean = String(t).trim();
  return clean.charAt(0).toUpperCase() + clean.slice(1).toLowerCase();
};

/** @returns {{label: string, value: string} | null} */
export function getVariantSpec(variant) {
  const opt = variant?.options?.[0];
  const value = opt?.value;
  if (isPlaceholder(value)) return null;
  const title = opt?.option?.title;
  const label = isPlaceholder(title)
    ? (/%/.test(value) ? 'Porcentaje' : 'Tamaño')
    : normalizeSpecLabel(title);
  return { label, value: normalizeSpecValue(value) };
}

/** Solo el valor ("30 ml"), o '' si la variante no tiene opción real. */
export function getVariantSpecValue(variant) {
  return getVariantSpec(variant)?.value || '';
}
